import { ChevronsUpDown } from "lucide-react";
import React, { useState } from "react";
import { account_name, can_visit, exchangeDate, location_name, usDate } from "../../helpers";
import Badge from "../UI/Badge";
import Skeleton from "react-loading-skeleton";
const maleAvatar = './images/avatar.png';
const femaleAvatar = './images/female.png';
const otherAvatar = './images/other.png';

const styles = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  cursor: "pointer",
};

export default function EligibilityLogsDataTable(props) {
  const {
    tableData = [],
    reloadData = () => {},
    reloadDataFilter = {},
    dataLoading,
    setDataLoading = () => {},
    previousScrollPosition = 0,
    setPreviousScrollPosition = () => {},
  } = props;

  const [orderBy, setOrderBy] = useState();
  const [patientData, setPatientData] = useState({});
  const [previsitViewStatus, setPrevisitViewStatus] = useState(false);

  const handleOrderChange = (name, type = "asc") => {
    name = name.toString();
    setOrderBy(name);
    if (reloadDataFilter.order_by && reloadDataFilter.order_by[0] == name) {
      if (reloadDataFilter.order_by[1] == "asc") {
        type = "desc";
      }
    }
    const orderFilter = { order_by: [name, type.toString()] };
    const filter_merge = { ...reloadDataFilter, ...orderFilter };
    reloadData(filter_merge);
    setDataLoading(true);
  };

  const handleViewPreVisit = (item) => {
    setPrevisitViewStatus(true);
    setPreviousScrollPosition(window.scrollY);
    window.scrollTo(0, 0);
    setPatientData(item);
  };


  return (
    <>
      <div className="docpro_table_responsive" style={{ minHeight: "450px" }}>
        <table className="docpro_mb_0" style={{ height: '100%' }}>
          <thead>
            <tr>
              {can_visit("_role_enterprise") && (
                <>
                  <th> Practice Name </th>
                  <th> Location </th>
                </>
              )}
              <th
                onClick={() => {
                  handleOrderChange("created_at");
                }}
                className={`${orderBy === "created_at" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                  Date <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th> Patient </th>
              <th> Insurance </th>
              <th> NPI Info </th>
              <th
                onClick={() => {
                  handleOrderChange("status");
                }}
                className={orderBy === "status" ? "docpro_accent_color" : ""}
              >
                <div style={styles}>
                  Status <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("error_code");
                }}
                className={`${orderBy === "error_code" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                  Error <ChevronsUpDown size={"12"} />
                </div>
              </th>
              <th
                onClick={() => {
                  handleOrderChange("error_follow_up_action");
                }}
                className={`${orderBy === "error_follow_up_action" ? "docpro_accent_color" : ""}`}
              >
                <div style={styles}>
                  Need Action <ChevronsUpDown size={"12"} />
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {!dataLoading ? (
              tableData.length > 0 ? (
                tableData?.map((item, index) => (
                  <tr key={index} className={`row_${item.id}`}>
                    {can_visit("_role_enterprise") && (
                      <>
                        <td onClick={() => handleViewPreVisit(item)}>
                          {account_name(item?.account_id)}
                        </td>
                        <td onClick={() => handleViewPreVisit(item)}>
                          {location_name(item?.location_id)}
                        </td>
                      </>
                    )}
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {usDate(item.created_at, true)}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      <div className="flex table_img">
                        <img src={item.sex === "M" ? maleAvatar : item.sex === "F" ? femaleAvatar : otherAvatar} alt="User" style={{ marginTop: 3 }} />
                        <div>
                          <p className="docpro_mb_0">
                            <b>Name: </b> {item?.last_name}{', '}{item?.first_name}
                          </p>
                          <p className="docpro_mb_0">
                            <b>DOB: </b> {exchangeDate(item?.dob)}{item?.sex === "M" ? ' (Male)' : item?.sex === "F" ? ' (Female)' : ' (Others)'}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      <div>
                        <p className="docpro_mb_0">
                          <b>Name: </b> {item?.insurance_name}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Insurance ID: </b> {item?.insurance_code}
                        </p>
                      </div>
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      <div>
                        <p className="docpro_mb_0">
                          <b>Number: </b> {item?.npi_number}
                        </p>
                        <p className="docpro_mb_0">
                          <b>Name: </b> {item?.provider_info?.npi_type === 'individual' ? `${item?.provider_info?.last_name} ${item?.provider_info?.first_name}` : item?.provider_info?.organization_name}
                        </p>
                      </div>
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {item?.status === "error" ? (
                        <Badge color="red">Error</Badge>
                      ) : item?.status === "success" ? (
                        <Badge color="green">Success</Badge>
                      ) : (
                        <Badge color="yellow">{item?.status}</Badge>
                      )}
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {item?.error_code ?
                        <>
                          <kbd className="docpro_kbd">{item.error_code}</kbd>{' '}
                          {item?.error_description || ''}
                        </>
                      : '-' }
                    </td>
                    <td className="pointer" onClick={() => handleViewPreVisit(item)}>
                      {item?.error_follow_up_action ? 
                        <div className="docpro_tip_checkbox">
                          {item.error_follow_up_action.length > 30
                            ? `${item.error_follow_up_action.slice(0, 30)}...`
                            : item.error_follow_up_action}
                          <span className="docpro_tip docpro_table_tip">{item.error_follow_up_action}</span>
                        </div>
                      : '-' }
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="no_data docpro_p_0" style={{ height: "450px" }} colSpan={`${can_visit("_role_enterprise") ? 9 : 7}`}>
                    No data available
                  </td>
                </tr>
              )
            ) : (
              Array.from({ length: 8 }).map((_, index) => (
                <tr key={index} style={{ height: '50px' }}>
                  {can_visit("_role_enterprise") && (
                    <>
                      <td> <Skeleton width={`${3 + (index % 2)}rem`} borderRadius="8px"></Skeleton> </td>
                      <td> <Skeleton width={`${4 + (index % 1.2)}rem`} borderRadius="8px"></Skeleton> </td>
                    </>
                  )}
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${5 + (index % 2.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 3)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="5rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width="3rem" borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${2 + (index % 1.5)}rem`} borderRadius="8px"></Skeleton> </td>
                  <td> <Skeleton width={`${4 + (index % 1.8)}rem`} borderRadius="8px"></Skeleton> </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
